import React from "react"
import Router from '@hkpca-web/config/router'

export default function ebook () {
  return (
    <Router />
  )
}
